module.exports = __webpack_public_path__ + "img/jl-icon_3.0d428008.png";